// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Printer from "@insite/mobius/Icons/Printer";
import { productDetailsButtonsStyles } from "@steiner/App/Components/Product/ProductDetailsButtons";
import { DivWrapper } from "@steiner/XDL/constants";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productDetailsButtonsStyles.container = {
    css: css`
        display: flex;
        align-items: baseline;
        column-gap: 24px;
        row-gap: 12px;
        flex-wrap: wrap;
        ${DivWrapper} {
            width: auto;
        }
        ${xScreen("lte", "md")} {
            margin-top: 20px;
        }
    `,
};

productDetailsButtonsStyles.printLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        weight: fontConfig.weight.semiBold,
    },
    icon: {
        iconProps: {
            src: Printer,
        },
    },
};
